export const listItem = {
  p: 0,
  color: "white",
  alignItems: "start",
  fontWeight: 400,
  "&::before": {
    content: "'\\2022'",
    fontWeight: 400,
    color: "white",
    fontSize: 14,
    marginRight: 1,
  },
}
